import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelRadio as _vModelRadio, vShow as _vShow, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-block pt-2" }
const _hoisted_2 = { class: "form-label fw-bolder" }
const _hoisted_3 = { value: null }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "d-block pt-2" }
const _hoisted_6 = { class: "form-label fw-bolder" }
const _hoisted_7 = { class: "d-block pt-2" }
const _hoisted_8 = { class: "form-label fw-bolder" }
const _hoisted_9 = { class: "form-check mt-3" }
const _hoisted_10 = { class: "form-check-label" }
const _hoisted_11 = ["value", "disabled"]
const _hoisted_12 = { class: "form-label fw-bolder" }
const _hoisted_13 = { class: "d-block pt-2" }
const _hoisted_14 = { class: "form-label fw-bolder" }
const _hoisted_15 = { class: "d-block pt-2" }
const _hoisted_16 = { class: "form-label fw-bolder" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "d-block pt-2" }
const _hoisted_19 = { class: "form-label fw-bolder" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_21 = { class: "d-flex justify-content-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputClearable = _resolveComponent("FormInputClearable")!
  const _component_FormTextAreaClearable = _resolveComponent("FormTextAreaClearable")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    show: _ctx.show,
    title: _ctx.t('AddProduct'),
    "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:show'))),
    closeOnOuterClick: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("label", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('AddProductTo')), 1),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.copyTo) = $event)),
            class: "form-select"
          }, [
            _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.t('CatalogAddNew')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.copyToOptions, (code) => {
              return (_openBlock(), _createElementBlock("option", {
                key: code,
                value: code
              }, _toDisplayString(code), 9, _hoisted_4))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.copyTo]
          ])
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('CatalogCode')), 1),
            _createVNode(_component_FormInputClearable, {
              modelValue: _ctx.code,
              validators: _ctx.validators.code,
              "onUpdate:modelValue": _ctx.onCodeUpdate
            }, null, 8, ["modelValue", "validators", "onUpdate:modelValue"])
          ]),
          _createElementVNode("label", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('CatalogDescription')), 1),
            _createVNode(_component_FormTextAreaClearable, {
              "model-value": _ctx.description,
              rows: 3,
              validators: _ctx.validators.description,
              "onUpdate:modelValue": _ctx.onDescriptionUpdate
            }, null, 8, ["model-value", "validators", "onUpdate:modelValue"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogOptions, (catalogOption) => {
            return (_openBlock(), _createElementBlock("div", {
              key: catalogOption.type
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ownerType) = $event)),
                    name: "catalogType",
                    type: "radio",
                    class: "form-check-input",
                    value: catalogOption.type,
                    disabled: !_ctx.catalogOptionsEditable
                  }, null, 8, _hoisted_11), [
                    [_vModelRadio, _ctx.ownerType]
                  ]),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t(`${catalogOption.type}Catalog`)), 1)
                ])
              ])
            ]))
          }), 128))
        ], 512), [
          [_vShow, _ctx.copyTo === null]
        ]),
        _createElementVNode("label", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('Quantity')), 1),
          _createVNode(_component_FormInputClearable, {
            modelValue: _ctx.quantity,
            validators: _ctx.validators.quantity,
            type: "number",
            "onUpdate:modelValue": _ctx.onQuantityUpdate
          }, null, 8, ["modelValue", "validators", "onUpdate:modelValue"])
        ]),
        _createElementVNode("label", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t('UnitOfMeasure')), 1),
          (!_ctx.unitOfMeasureEditable)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "text",
                class: "form-control",
                value: _ctx.unitOfMeasure,
                disabled: ""
              }, null, 8, _hoisted_17))
            : (_openBlock(), _createBlock(_component_FormInputClearable, {
                key: 1,
                modelValue: _ctx.unitOfMeasure,
                validators: _ctx.validators.unitOfMeasure,
                "onUpdate:modelValue": _ctx.onUOMUpdate
              }, null, 8, ["modelValue", "validators", "onUpdate:modelValue"]))
        ]),
        _createElementVNode("label", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t('ProductDescription')), 1),
          _createVNode(_component_FormTextAreaClearable, {
            "model-value": _ctx.productDescription,
            rows: 3,
            validators: _ctx.validators.productDescription,
            "onUpdate:modelValue": _ctx.onProductDescriptionUpdate
          }, null, 8, ["model-value", "validators", "onUpdate:modelValue"])
        ]),
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_Btn, {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.close()), ["prevent"])),
            class: "mx-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Cancel', true)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Btn, {
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.onSave()), ["prevent"])),
            disabled: !_ctx.isFormValid,
            primary: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Save', true)), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["show", "title"]))
}